import React from 'react'
import Modal from 'react-modal'
import { useSelector, useDispatch } from 'react-redux'
import './ModalTheme.css';

// Import each "modal content" component separately
import NewDiagramModalContent from './modalContent/NewDiagramModalContent';
import ExportExcelModalContent from './modalContent/ExportExcelModalContent';
import { closeModal } from '../../../redux/reducers/global/modal/modalSlice';
import NewFolderModalContent from './modalContent/NewFolderModalContent';
import DistributionBoardModalContent from './modalContent/DistributionBoardModalContent';
import ConfirmExportModalContent from './modalContent/ConfirmExportModalContent';
import ConfirmExportPdfModalContent from './modalContent/ConfirmExportPdfModalContent';
import ShortcutsModalContent from './modalContent/ShortcutsModalContent';
import SettingsModalContent from './modalContent/SettingsModalContent';
import ConfirmExitModalContent from './modalContent/ConfirmExitModalContent';
import { clearModalTask } from './modalTaskRegistry';
import KnowledgeTutorialModalContent from './modalContent/KnowledgeTutorialModalContent';
import KnowledgeVideoModalContent from './modalContent/KnowledgeVideoModalContent';
import AuthLoginModalContent from './modalContent/AuthLoginModalContent';
import { MODAL_TYPES } from './modalTypes';

function ModalRoot() {
  const dispatch = useDispatch()
  const { isOpen, modalType, modalProps } = useSelector((state) => state.modal)

  const handleClose = () => {
    if (modalProps?.taskId) {
      clearModalTask(modalProps.taskId);
    }
    dispatch(closeModal())
  }

  let renderedModalContent = null

  const isNewDiagramModal = modalType === MODAL_TYPES.NEW_DIAGRAM;
  const isNewFolderModal = modalType === MODAL_TYPES.NEW_FOLDER;
  const isExitProjectsModal = modalType === MODAL_TYPES.CONFIRM_EXIT_PROJECTS;
  const isSettingsModal = modalType === MODAL_TYPES.EDITOR_SETTINGS;
  const useCreateStyle = isNewDiagramModal || isNewFolderModal || isExitProjectsModal || isSettingsModal;
  switch (modalType) {
    case MODAL_TYPES.NEW_DIAGRAM:
      renderedModalContent = (
        <NewDiagramModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.EXPORT_EDITOR_EXCEL:
      renderedModalContent = (
        <ExportExcelModalContent onClose={handleClose} {...modalProps} />
      )
      break
      case MODAL_TYPES.NEW_FOLDER:
        renderedModalContent = (
          <NewFolderModalContent onClose={handleClose} {...modalProps} />
        )
        break

      case MODAL_TYPES.OPEN_DISTRIBUTION_BOARD:
        renderedModalContent = (
          <DistributionBoardModalContent onClose={handleClose} {...modalProps} />
        )
        break
    case MODAL_TYPES.EXPORT_EDITOR_PNG:
    case MODAL_TYPES.EXPORT_EDITOR_DXF:
      renderedModalContent = (
        <ConfirmExportModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.EXPORT_EDITOR_PDF:
      renderedModalContent = (
        <ConfirmExportPdfModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.EDITOR_SHORTCUTS:
      renderedModalContent = (
        <ShortcutsModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.EDITOR_SETTINGS:
      renderedModalContent = (
        <SettingsModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.CONFIRM_EXIT_PROJECTS:
      renderedModalContent = (
        <ConfirmExitModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.KNOWLEDGE_TUTORIAL:
      renderedModalContent = (
        <KnowledgeTutorialModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.KNOWLEDGE_VIDEO:
      renderedModalContent = (
        <KnowledgeVideoModalContent onClose={handleClose} {...modalProps} />
      )
      break
    case MODAL_TYPES.AUTH_LOGIN:
      renderedModalContent = (
        <AuthLoginModalContent onClose={handleClose} {...modalProps} />
      )
      break
    default:
      renderedModalContent = null
  }

  const useExportChrome = modalType === MODAL_TYPES.EXPORT_EDITOR_EXCEL
    || modalType === MODAL_TYPES.EXPORT_EDITOR_PNG
    || modalType === MODAL_TYPES.EXPORT_EDITOR_DXF
    || modalType === MODAL_TYPES.EXPORT_EDITOR_PDF;
  const isKnowledgeModal = modalType === MODAL_TYPES.KNOWLEDGE_TUTORIAL || modalType === MODAL_TYPES.KNOWLEDGE_VIDEO;
  const modalClassName = (() => {
    if (useExportChrome) return 'app-modal app-modal--export';
    if (modalType === MODAL_TYPES.EDITOR_SHORTCUTS) return 'app-modal app-modal--shortcuts';
    if (isKnowledgeModal) return 'tutorial-modal-wrapper';
    if (useCreateStyle) return 'app-modal app-modal--create modal-newdiagram modal-newdiagram--create';
    return 'app-modal app-modal--default modal-newdiagram';
  })();

  const overlayClassName = (() => {
    if (useExportChrome) return 'app-modal-overlay app-modal-overlay--export';
    if (isKnowledgeModal) return 'tutorial-modal-overlay';
    if (useCreateStyle) return 'app-modal-overlay app-modal-overlay--create modal-newdiagram-overlay modal-newdiagram-overlay--create';
    return 'app-modal-overlay app-modal-overlay--default modal-newdiagram-overlay';
  })();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Modal"
      className={modalClassName}
      overlayClassName={overlayClassName}
    >
      {renderedModalContent}
    </Modal>
  )
}

export default ModalRoot
